var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('m-bread-crumb'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"about spad"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('div',{staticClass:"section-title about-title"},[_c('u',[_c('h2',[_vm._v("Política de Privacidade e Protecção de Dados Pessoais")])]),_c('br'),_c('br')])])])])])
}]

export { render, staticRenderFns }